<template>
	<div class="bg-white shadow-sm rounded" style="border: 1px solid rgb(222, 222, 222, 0.5)">
		<div v-if="!configcollection?.hidePostHeader" class="flex items-center p-3 border-b border-gray-200 flex-wrap">
			<div class="flex">
				<EditButton v-if="configcollection?.editmode && !configcollection?.hideConfigButton" class="rounded hover:bg-secondary-500/80 items-center py-1 px-1 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white mr-2"
				:id="callout.identifier" type="configAssistantMode"/>
				<InplaceEdit
					v-if="configcollection?.editmode && configcollection?.id != 'language_review'"
					:inputProps="[{ content: callout.packageTitle, propName: 'packageTitle', inputType: 'packageTitle' }]"
					:collectionMode="configcollection"
					:href="callout._links?.self?.href" blockTitle="Edit package title" :showAssistant="true">
					<strong class="ml-1">{{ callout.packageTitle }}</strong>
				</InplaceEdit>
					<strong v-else class="ml-1">{{ callout.packageTitle }}</strong>
			</div>
			<div class="ml-auto flex items-center">
				<EditButton
					class="rounded flex flex-row hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white mr-2"
					v-if="!configcollection?.hideFeedbackListButton && hasFeedbackListUrl"
					:modal="isModalFeedback"
					:id="callout.identifier" type="feedbackList"
					:buttonLabel="'Feedback List'"
					@click="console.log('FeedbackListUrl:', feedbackListUrl)"
					:overrideURL="feedbackListUrl" />

					
				<button v-if="configcollection?.editmode && !configcollection?.hideDeleteActions"
					class="rounded hover:bg-danger-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-danger-500 transition-all bg-danger !text-white mr-2" @click="deleteItem(callout._links?.self?.href)">
					<i class="tabler:trash w-5 h-5 text-white flex"></i>
				</button>
				<EditButton v-if="configcollection?.editmode && !configcollection?.hideEditAll"
					class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white"
					:id="callout.identifier" icon="tabler:settings" type="editPackage"
					@click="console.log('editPackageUrl:', editPackageUrl)"
					:overrideURL="editPackageUrl" />
			</div>
		</div>
		<div class="flex flex-col  sm:flex-row justify-center">
			<div class="mx-3 py-3 sm:w-4/12 md:w-2/12 lg:w-2/12 mb-3" v-if=" showGallery ">
				<InteractiveImage alt="Image" preview class="rounded">
					<template #indicatoricon>
						<i class="tabler:eye w-8 h-8 text-white"></i>
					</template>
					<template #image>
						<EditButton v-if=" configcollection?.editmode  && callout.mainOutcome?.imageSrcEdit"
						class="absolute right-[0px] top-[0px] p-2 z-2 text-white bg-danger rounded hover:bg-danger-200 hover:!text-white"
						:id="callout.identifier" :type=" configcollection?.id != 'language_review' ? 'imageattr' : 'lngReviewEdit'" 
						:icon=" configcollection?.id == 'language_review' ? 'tabler:photo-edit' : 'tabler:photo-edit'"
						:overrideURL="callout.mainOutcome?.imageSrcEdit" />

						<img :src="callout.mainOutcome?.imageSrc"
							class="img-thumbnail md:w-100% sm:w-[220px] object-contain overflow-hidden md:max-h-280px border"
							alt="image" />
					</template>
					<template #preview="slotProps">
						<div class="p-5 w-[70%] mx-auto">
							<div v-if="callout.mainOutcome?.imageTitle" class="text-mb mb-3 font-bold text-white">
								{{ callout.mainOutcome?.imageTitle }}
							</div>

							<img :src="callout.mainOutcome?.imageSrc" alt="preview" class="mx-auto max-h-[720px]"
								:style="slotProps.style" @click="slotProps.onClick" />
							<div v-if=" callout.mainOutcome.imageCopyright "
								class="text-xs mt-3 mb-3 font-bold text-white text-right">
								{{ callout.mainOutcome?.imageCopyright }}
							</div>
							<div v-if=" callout.mainOutcome.imageDescription "
								class="text-mb mt-3 mb-3 font-bold text-white">
								{{ callout.mainOutcome?.imageDescription }}
							</div>
						</div>
					</template>
				</InteractiveImage>
				<div v-if=" callout.mainOutcome?.imageCopyright "
					class="text-[0.56rem] mt-1 mb-1 text-right">
					{{ callout.mainOutcome.imageCopyright }}
				</div>
			</div>
			<div class="px-4 py-2 sm:w-8/12 md:w-9/12 lg:w-9/12 flex-1 relative">
				<EditButton
					class="absolute right-5px top-[5px] inline-flex items-center gap-2 transition-all rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
					v-if=" configcollection?.editmode && callout._links?.mainOutcome " :id="callout.identifier"
					:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'listattr'"
					:overrideURL="callout._links?.mainOutcome?.href" />
				<InplaceEdit
					:collectionMode="configcollection"
					:enableCollapseSection="true"
					:extraContent="callout.mainOutcomeBl.selectHeader"
					:inputProps="[{ content: callout.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
					:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true">
					<h6
						class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
						{{ callout.mainOutcome.selectHeader }}
					</h6>
				</InplaceEdit>
				<div class="full-content">
					<div class="main-text md:line-clamp-3">
						<div class="flex items-center">
							<InplaceEdit
								:collectionMode="configcollection"
								:enableCollapseSection="true"
								:extraContent="callout.mainOutcomeBl.title"
								:inputProps="[{ content: callout.mainOutcome.title, propName: 'title', inputType: 'textarea' }]"
								:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit title"  :showAssistant="true"
								:textarea-props="{ rows: 3, class: 'min-w-[30rem]' }">
									<h4
										class="mb-2 inline-flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
										<span v-if="configcollection?.id === 'audience'">
											{{ callout.mainOutcome.title }}
										</span>
										<span v-else>
											<!-- <EditButton class="!text-left" :id="callout.identifier" :buttonLabel="callout.mainOutcome.title" :headerTitle="callout.packageTitle" type="details" :overrideURL="learnMoreDetailsUrl" >
												{{ callout.mainOutcome.title }}
											</EditButton> -->
											<EditButton class="!text-left" :id="callout.identifier" :buttonLabel="callout.mainOutcome.title" :headerTitle="callout.packageTitle" type="print" :overrideURL="learnMoreDetailsUrl" >
												{{ callout.mainOutcome.title }}
											</EditButton>
										</span>
									</h4>
							</InplaceEdit>
							<span class="badge badge-sm ml-2" v-if=" callout.flagMode && configcollection?.id === 'authoring' " 
							:class="{ 'badge-danger': callout.flagMode === 'au', 'badge-success': callout.flagMode === 'as' }">
								{{ callout.flagMode === 'au' ? 'Author First' : callout.flagMode === 'as' ? 'Assistant First' : callout.flagMode }}
							</span>

						</div>

						<div class="inline">
							<div
								class="font-sans text-sm font-normal leading-relaxed text-gray-700 antialiased mb-2 line-clamp-2 flex items-center">
								<InplaceEdit v-if="callout._links?.mainOutcomeEdit?.href && configcollection?.id != 'language_review'"
									:collectionMode="configcollection"
									:inputProps="[{ content: callout.mainOutcome?.publishingDate, propName: 'other.publishingDate', inputType: 'datepicker' }]"
									:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit publishing date">
									<div class="text-sm">{{ publishingDateFormated }}</div>
								</InplaceEdit>
									<div v-else class="text-sm">{{ publishingDateFormated }}</div>
								<div id="AuthorList" class="flex flex-row items-center">
									<InplaceEdit v-if="callout._links?.mainOutcomeEdit?.href && configcollection?.id != 'language_review'" 
									:collectionMode="configcollection"
									:inputProps="[{
										content: callout.mainOutcome?.authorIdentifier, propName: 'other.authorIdentifier', inputType: 'select', selectProps: {
											optionValue: 'identifier',
											optionLabel: 'title',
											class: 'w-15rem',
											optionsCvKey: 'author',
											
										}
									}]" :href="callout._links?.mainOutcomeEdit?.href || ''" blockTitle="Edit author">
										<div class="ml-2 text-sm font-bold" v-html="callout.mainOutcome.author"> </div>
									</InplaceEdit>
									<div v-else class="ml-2 text-sm font-bold" v-html="callout.mainOutcome.author"> </div>
								</div>

							</div>
							<div
								class="flex items-center font-sans text-sm font-normal leading-relaxed text-gray-700 antialiased mb-2 line-clamp-2">
								<div id="editLeadText" class="flex items-end relative">
									<InplaceEdit
										:collectionMode="configcollection"
										:enableCollapseSection="true"
										:extraContent="callout.mainOutcomeBl.leadText"
										:inputProps="[{ content: callout.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
										:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
										<div v-html="callout.mainOutcome.leadText"></div>
									</InplaceEdit>

								</div>
							</div>

							<!-- ky button sherben per te hap detajet nepermjet routerlink -->
							
							<!-- <EditButton
								v-if="!configcollection?.hidePrintMore"
								class="flex-1 underline cursor-pointer md:text-sm text-sm"
								:id="callout.identifier"
								:buttonLabel="labels.readmode"
								:toolTipLabel="AppConfig.urls.print?.toolTipLabel"
								:overrideURL="learnMoreDetailsUrl"
								:headerTitle="callout.packageTitle"
								type="details"
							/> -->
							<EditButton v-if="!configcollection?.hidePrintMore"
								class="flex-1 underline cursor-pointer md:text-sm text-sm" :class="!configcollection?.hideLearnMore ? 'ml-2' : 'ml-0'"
								:id="callout.identifier" :buttonLabel="labels.readmode" :toolTipLabel="AppConfig.urls.print?.toolTipLabel" :overrideURL="learnMoreDetailsUrl"  :headerTitle="callout.packageTitle" type="print" />

						</div>
					</div>
					<div class="flex items-center">
						<div  class="btn-group flex flex-wrap pt-3 pb-2 w-full">
							<!-- <button type="button"
								class="flex flex-row hover:bg-primary-500/80 items-center rounded py-2 px-2 mt-3 text-center font-sans mr-2 text-xs font-bold transition-all bg-primary text-white block md:hidden"
								@click="showGallery = !showGallery">
								<i class="tabler:photo-up w-5 h-5"></i>
								<span class="hidden md:inline ml-1">Image</span>
							</button> -->

							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"  v-if="callout._links?.preQuiz?.href && !configcollection?.hidePreQuizButton"
								:class="{ 'rounded-e mr-2': !configcollection?.editmode }" type="button"
								@click="() => { console.log('Going to:', preQuizUrl); openPreQuizDialog(); }">
								<i class="tabler:list-check w-5 h-5 mr-1"></i>
								<span class="hidden md:inline">{{ labels.prequiz }}</span>
							</button>
							<EditButton v-if=" configcollection?.editmode && callout._links?.preQuiz?.href"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center mr-2 mt-3 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="callout.identifier" 
								:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'prequiz'"								
								:overrideURL="callout._links?.preQuiz?.href" />


							<DialogModal :visible="showPrequziDialog" modal :header="labels.prequiz"
								:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
								@update:visible="showPrequziDialog = false">
								<EditButton v-if=" configcollection?.editmode " class="absolute right-53px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
									:id="callout.identifier" 
									:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'prequiz'"								
									:overrideURL="callout._links?.preQuiz?.href" />
								<PreQuiz :jsonData="callout" @close="showPrequziDialog = false"
												:overrideURL="preQuizUrl" :selectedLanguage='selectedLanguage' :collectionMode="configcollection" />
							</DialogModal>
							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 mr-0 text-center font-sans text-xs font-bold transition-all bg-primary text-white" v-if="callout.mainOutcome.keyMessages && !configcollection?.hideKeyMessagesButton"
								:class="{ 'rounded-e mr-2': !configcollection?.editmode }" type="button"
								@click="() => { console.log('Going to KeyMessages:', keyMessagesUrl); openKeyMessagesDialog(); }">
								<i class="tabler:list-numbers w-5 h-5 mr-1"></i>
								<span class="hidden md:inline">{{ labels.keymessages }}</span>
							</button>
							<EditButton class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center mt-3 mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							v-if=" configcollection?.editmode && callout._links?.mainOutcome && callout.mainOutcome.keyMessages " :id="callout.identifier" 
							:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'listattr'"
							:overrideURL="callout._links?.mainOutcome?.href" />
							<DialogModal :visible="showKeymessagesDialog" modal :header="labels.keymessages"
								:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
								@update:visible="showKeymessagesDialog = false">
								<!-- <EditButton class="absolute right-80px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							v-if=" configcollection?.editmode && callout._links.mainOutcome " :id="callout.identifier" type="listattr"
							:overrideURL="callout._links.mainOutcome.href" /> -->

								<!-- Loading State -->
								<div v-if="isLoadingKeyMessages" class="flex items-center justify-center py-10">
									<i class="tabler:loader-2 w-8 h-8 animate-spin text-primary"></i>
									<span class="ml-2">Loading...</span>
								</div>
								<div v-else id="editKeyMessagges" class="flex items-end">
									<InplaceEdit
										:inputProps="[{ content: keyMessagesContent, propName: 'other.keyMessages', inputType: 'editor' }]"
										:enableCollapseSection="true"
										:extraContent="callout.mainOutcomeBl.keyMessages"
										:href="callout._links?.mainOutcomeEdit?.href" blockTitle="Edit key Messages"  :showAssistant="true">
										<div id="editKeyMessaggesWrapper" v-html="keyMessagesContent"></div>
									</InplaceEdit>
								</div>
							</DialogModal>


							<template v-if=" !isTextOnlyOutput ">
								<PlayerButton v-if=" !configcollection?.hideReadittomeButton && callout.file_url"
									:file_url="playerFileUrl"
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
									:class="{ 'rounded-e mr-2': !configcollection?.editmode }"
									:language="selectedLanguage" :isPlaying="isPlaying"
									@togglePlayback="emit( 'play', callout.identifier )" />

									<EditButton 
										v-if="configcollection?.editmode && callout.file_url"
										class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 mt-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
										
										:id="callout.identifier" 
										:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'podcast'"								
										:overrideURL="callout._links?.podcastSlideshowConversations?.href"
									/>

								<!-- <button v-if=" !configcollection?.hidePresentationButton"
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-3 text-center mt-3 font-sans text-xs font-bold transition-all bg-primary text-white"
									:class="{ 'rounded-e': !configcollection?.editmode }"
									type="button" @click="emit( 'toPresentation', callout.identifier || '' )">
									<i class="tabler:presentation w-5 h-5 mr-1"></i>

									<span class="hidden md:inline">{{ labels.presentation }}</span> 
								</button> -->
								<EditButton v-if="!configcollection?.hidePresentationButton"
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 text-center mt-3 font-sans text-xs font-bold transition-all bg-primary text-white" :class="[ configcollection?.hidePresentationButton ? 'ml-2' : 'ml-0', { 'rounded-e': !configcollection?.editmode }]"

									:id="callout.identifier" :buttonLabel="`${labels.presentation}`" :toolTipLabel="`${labels.presentation}`"  :headerTitle="callout.mainOutcome.title" type="slideshow" />

									<EditButton
										v-if="configcollection?.editmode"
										class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-2 text-center font-sans mt-3 text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
										:id="callout.identifier"
										:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'slideshowEdit'"
										:overrideURL="callout?._links?.podcastSlideshow?.href"
									/>
							</template>
								<button
									class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 mt-3 text-center font-sans text-xs font-bold transition-all bg-primary text-white ml-2"
									v-if="callout._links?.postQuiz?.href"
									:class="{ 'rounded-e mr-2': !configcollection?.editmode }" type="button"
									@click="() => { console.log('Going to PostQuiz:', postQuizUrl); openPostQuizDialog(); }">
									<i class="tabler:list-check w-5 h-5 mr-1"></i>
									<span class="hidden md:inline">{{ labels.postquiz }}</span>
								</button>
								<EditButton v-if=" configcollection?.editmode && callout._links?.postQuiz?.href"
									class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 mt-3 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
									:id="callout.identifier" 
									:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"
									:overrideURL="callout._links?.postQuiz?.href" />
								<DialogModal :visible="showPostquizDialog" modal :header="labels.postquiz"
									:style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
									@update:visible="showPostquizDialog = false">

									<EditButton v-if="configcollection?.editmode" class="absolute right-53px top-20px rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white" :id="callout.identifier" 
									:type="configcollection?.id === 'language_review' ? 'lngReviewEdit' : 'postquiz'"								
									:overrideURL="callout._links?.postQuiz?.href" />
									<PostQuiz
										:jsonData="callout" :overrideURL="postQuizUrl"  :collectionMode="configcollection" :selectedLanguage="selectedLanguage" @close="showPostquizDialog = false" />
								</DialogModal>

						<div v-if="!configcollection?.hideReadCallAssistantButton || !configcollection?.hideFeedbackButton" class="ml-auto gap-2 mt-3 flex">
							<EditButton
								class="rounded hover:bg-secondary-500/80 items-center py-2 px-2 text-center font-sans text-xs font-bold hover:text-success-500 transition-all bg-secondary !text-white"
								v-if="!configcollection?.hideReadCallAssistantButton"
								:modal="isModalCallAssistant"
								:id="callout.identifier" type="readCallAssistantButton"
								:overrideURL="callout._links?.helpSupportAssistantLink?.href"
								:headerTitle="callout.mainOutcome.title"
								:buttonLabel="AppConfig.urls.assistantModeButtons?.readCallAssistantButton.buttonLabel"
								:toolTipLabel="AppConfig.urls.assistantModeButtons?.readCallAssistantButton.toolTipLabel"
								 />
							<!-- menyra e vjeter e feedback -->
							<EditButton
								class="rounded flex flex-row hover:bg-primary-500/80 items-center py-2 px-2 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
								v-if="!configcollection?.hideFeedbackButton && AppConfig.urls.feedback?.url"
								:modal="isModalFeedback"
								:id="callout.identifier" type="feedback"
								:buttonLabel="AppConfig.urls.feedback?.buttonLabel"
								:toolTipLabel="AppConfig.urls.feedback?.toolTipLabel"
								@click="console.log('Going to:', feedbackUrl)"
								:overrideURL="feedbackUrl" />

							<!-- <EditButton
								class="rounded flex flex-row hover:bg-primary-500/80 items-center ml-2 py-2 px-2 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
								v-if="!configcollection?.hideFeedbackButton && AppConfig.urls.notification?.url"
								:id="callout.identifier" type="notification"
								:buttonLabel="AppConfig.urls.notification?.buttonLabel"
								:toolTipLabel="AppConfig.urls.notification?.toolTipLabel"
								@click="console.log('Going to:', notificationUrl)"
								:overrideURL="notificationUrl" /> -->
						</div>
						</div>									
								
								<!-- menyra e re e feedback -->
								<!-- <button
									class="rounded flex flex-row hover:bg-primary-500/80 mt-3 items-center ml-2 py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
									v-if="showFeedbackButton"
									@click="goToFeedbackPage"
								>
									<i class="tabler:message w-5 h-5 mr-1"></i>
									<span>Feedback</span>
								</button> -->
						
					</div>
				</div>
			</div>
		</div>
		<div v-if="!configcollection?.hidePostFooter" class="flex items-center p-3 border-t border-gray-200 flex-wrap">
				<EditButton v-if=" !configcollection?.hideWorkflowStates && configcollection?.editmode && callout.assistantStatus !== 'in progress' && callout._links?.personalAssistantProcessingLink?.href !== '' " class="flex items-center gap-2 mr-2 border rounded px-2 py-[6.5px] border-danger text-danger"
					:id="callout.identifier" type="assistantMode"
					:overrideURL="callout._links?.personalAssistantProcessingLink?.href"
					:buttonLabel="callout.workflowState || 'Workflow State'"
					:toolTipLabel="`Workflow Step: ${callout.workflowState }`"
				/>
				<AssistantDropdown
					v-if="!configcollection?.hiddeAssistantComponent" 
					:callout="callout"
					:AppConfig="AppConfig"
					:showhelpSupportAssistantButton="showhelpSupportAssistantButton"
					:showassistantComplainceButton="showassistantComplainceButton"
					:showassistantReportButton="showassistantReportButton"
					:showFeedbackassistantButton="showFeedbackassistantButton"
					:showCallAssistantButton="showCallAssistantButton"
				/>

			<div class="ml-auto flex items-center flex-wrap md:flex-nowrap gap-2">
				<!-- <EditButton v-if=" configcollection?.editmode && callout.assistantStatus === 'in progress' && callout._links?.assistantProcessingLink?.href !=='' " class="flex items-center gap-2 mr-2 border rounded px-2 py-[6.5px] border-danger text-danger"
				:id="callout.identifier" type="processingassistantMode"
				:overrideURL="callout._links?.assistantProcessingLink?.href"
				/> -->
				<div v-if="!configcollection?.hideAuthoringStatus">
				<AuthoringStatus
					v-if="callout.assistantStatus !== 'in progress'"
					v-tooltip.top="'Package Authoring Status'"
					:class="{ 'disabled' : configcollection?.disabledAuthoringStatus }"
					:uid="callout.identifier"
					:jsonData="callout"
					:optionLabel="callout.authoringStatusCode"
					:statusOptions="authoringStatusOptions"
					:optionValue="authoringStatus"
					:key="callout.identifier"
					@statusChange="authoringStatusChange"
				/>
				</div>

				<div v-if="!configcollection?.hideReviewStatus">
				<ReviewStatus
					v-if="callout.assistantStatus !== 'in progress'"
					v-tooltip.top="'Package Review Status'"
					:class="{ 'disabled' :  configcollection?.disabledReviewStatus }"
					:uid="callout.identifier"
					:jsonData="callout"
					:optionLabel="callout.reviewStatusCode"
					:reviewStatusOptions="reviewStatusOptions"
					:optionValue="reviewStatus"
					:key="callout.identifier"
					@statusChange="reviewStatusChange"
				/>
				</div>
				<div v-if="!configcollection?.hidePublishingStatus">
				<PublishingStatus v-if="callout.assistantStatus !== 'in progress'" v-tooltip.top="'Package Publishing Status'" :uid="callout.identifier"
					:jsonData="callout" :optionLabel="callout.publishingStatusCode" :lng="selectedLanguage"
					:class="{ 'disabled' : configcollection?.disabledPublishingStatus }"
					:statusOptions="publishingStatusOptions"
					:optionValue="callout.publishingStatusCode" :key="callout.identifier"
					@statusChange="publishingStatusChange" />
				</div>
				<NotificationDropdown
					v-if="!configcollection?.hiddeNotificationList" 
					:callout="callout"
					:AppConfig="AppConfig"
					:configcollection="configcollection"
					:class="{ 'disabled' : configcollection?.disableNotify }"
					:selectedLanguage="selectedLanguage"
					:hiddeNotifyReviewers="!configcollection?.hiddeNotifyReviewers"
					:hiddeNotifyLanguageReviewers="!configcollection?.hiddeNotifyLanguageReviewers"
					:hiddeNotifyEditorPublisher="!configcollection?.hiddeNotifyEditorPublisher"
					:hiddeNotifyAudience="!configcollection?.hiddeNotifyAudience"
					:hiddeProductionTeam="!configcollection?.hiddeProductionTeam"
				/>

			</div>
		
		</div>

	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { DateTime } from "luxon";

import { useAppConfig } from '@/composables/useAppConfig';
import type { Callout, LanguageCodes, configCollectionMode } from '@/types'
import { messages } from '@/assets/language';
import { useRouter } from 'vue-router'
import EditButton from '@/components/EditButton.vue'
import PreQuiz from '@/components/PreQuiz.vue'
import PostQuiz from '@/components/PostQuiz.vue'
import AssistantDropdown from '@/components/AssistantDropdown.vue';
import PlayerButton from '@/components/PlayerButton.vue'
import AuthoringStatus from '@/components/AuthoringStatus.vue'
import ReviewStatus from './ReviewStatus.vue';
import PublishingStatus from '@/components/PublishingStatus.vue'
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue'
import NotificationDropdown from '@/components/NotificationDropdown.vue';
import { useAppStore } from '@/stores/app-store'

const AppConfig = useAppConfig()
const { currentLng, currentCollectionMode, currentTestyourself, currentPAGE_REQ_ID } = useAppStore()


const props = withDefaults( defineProps<{
	callout: Callout;
	configcollection: configCollectionMode | null
	isTextOnlyOutput?: boolean
	isPlaying?: boolean
	isEditMode?: boolean
	hideActions?: boolean
	selectedLanguage?: LanguageCodes
	authoringStatusOptions?: Array<{ identifier: string; title: string; disabled?: boolean }>;
	reviewStatusOptions?: Array<{ identifier: string; title: string; disabled?: boolean }>;
	publishingStatusOptions?: Array<{ identifier: string; title: string }>;
}>(), {
	isTextOnlyOutput: false,
	isPlaying: false,
	isEditMode: false,
	hideActions: false,
	selectedLanguage: 'de'
} )

const emit = defineEmits<{
	play: [Callout['identifier']]
	toPresentation: [Callout['identifier']]
	reviewStatusChange: [Callout['reviewStatusCode']]
	authoringStatusChange: [Callout['authoringStatusCode']]
	publishingStatusChange: [Callout['publishingStatusCode']]
	titleUpdate: ['title-update']
	delete:[string]
	statusesChange: [{
		id: Callout['identifier'],
		authoring: Callout['authoringStatusCode'],
		review: Callout['reviewStatusCode']
	}]
}>()

const authoringStatus = ref<Callout['authoringStatusCode']>(props.callout.authoringStatusCode)
const reviewStatus    = ref<Callout['reviewStatusCode']>(props.callout.reviewStatusCode)

const authoringDisabled = ref(false)
const reviewDisabled    = ref(false)

// sinkronizo lokalet nëse prindi (ListView) sjell callout të ri
watch(() => props.callout.authoringStatusCode, (v) => {
  if (v && v !== authoringStatus.value) {
    authoringStatus.value = v
    // Authoring -> Review, 1:1 si rregullat e tua
    if (v === "n")      { reviewStatus.value = "n"; reviewDisabled.value = false }
    else if (v === "d") { reviewStatus.value = "n"; reviewDisabled.value = false }
    else if (v === "f") { reviewStatus.value = "d"; reviewDisabled.value = false }
  }
})
watch(() => props.callout.reviewStatusCode, (v) => {
  if (v && v !== reviewStatus.value) {
    reviewStatus.value = v
    // Review -> Authoring, 1:1 si rregullat e tua
    if      (v === "f" || v === "e") { authoringStatus.value = "f"; authoringDisabled.value = false }
    else if (v === "d")              { authoringStatus.value = "f"; authoringDisabled.value = false }
    else if (v === "n")              { authoringStatus.value = "n"; authoringDisabled.value = false }
  }
})

async function authoringStatusChange ( newStatus: Callout['authoringStatusCode'] ) {
	authoringStatus.value = newStatus

	if (newStatus === "n") {
		reviewStatus.value = "n"
		reviewDisabled.value = false
	}
	else if (newStatus === "d") {
		reviewStatus.value = "n"
		reviewDisabled.value = false
	}
	else if (newStatus === "f") {
		reviewStatus.value = "d"   // finalized -> draft
		reviewDisabled.value = false
	}

	emit( 'authoringStatusChange', newStatus )

	// (opsionale) njofto ListView për refresh ose update optimist
	await nextTick()
	emit('statusesChange', {
		id: props.callout.identifier,
		authoring: authoringStatus.value,
		review: reviewStatus.value
	})
}

// Review -> Authoring (thirret nga @statusChange i ReviewStatus)
async function reviewStatusChange ( newStatus: Callout['reviewStatusCode'] ) {
	reviewStatus.value = newStatus

	if (newStatus === "f" || newStatus === "e") {
		authoringStatus.value = "f"
		authoringDisabled.value = false
	}
	else if (newStatus === "d") {
		authoringStatus.value = "f"
		authoringDisabled.value = false
	}
	else if (newStatus === "n") {
		authoringStatus.value = "d"
		authoringDisabled.value = false
	}

	emit('reviewStatusChange', newStatus)

	await nextTick()
	emit('statusesChange', {
		id: props.callout.identifier,
		authoring: authoringStatus.value,
		review: reviewStatus.value,
	})
}

// Publishing mbetet i pandryshuar
async function publishingStatusChange ( newStatus: Callout['publishingStatusCode'] ) {
	emit('publishingStatusChange', newStatus)

	await nextTick()
	emit('statusesChange', {
		id: props.callout.identifier,
		authoring: authoringStatus.value,
		review: reviewStatus.value,
	})
}

// Inicializim – ekuivalent i initializeStatusLogic()
onMounted(() => {
	const a = authoringStatus.value
	const r = reviewStatus.value

	// disable opsionin "n" në arrays (PrimeVue e respekton .disabled)
	props.authoringStatusOptions?.forEach(o => { if (o.identifier === "n") (o as any).disabled = false })
	props.reviewStatusOptions?.forEach(o => { if (o.identifier === "n") (o as any).disabled = false })

	// rasti special: authoring=d & review=n -> disable review
	if (a === "d" && r === "n") reviewDisabled.value = false

	// nëse të dyja janë "n" -> disable të dyja
	if (a === "n" && r === "n") {
		authoringDisabled.value = false
		reviewDisabled.value = false
	}
})
/* ==================== fund seksionit të lidhjes ==================== */

const deleteItem = (url: string) => {
//   console.log('Deleting item:', url);
  emit('delete', url);
};

const hasFeedbackListUrl = computed(() => AppConfig.urls.feedback?.listUrl !== '')

const isModalFeedback = computed(() => AppConfig.urls.feedback?.modal === true)

const showassistantComplainceButton = computed(() => AppConfig.urls.assistantModeButtons?.complainceButton.enabled === true && AppConfig.urls.assistantModeButtons?.complainceButton.complainceAssistantLink !== '')
const showhelpSupportAssistantButton = computed(() => AppConfig.urls.assistantModeButtons?.helpSupportAssistantButton.enabled === true)
const showassistantReportButton = computed(() => AppConfig.urls.assistantModeButtons?.reportButton.enabled === true && AppConfig.urls.assistantModeButtons?.reportButton.reportAssistantLink !== '')
const showFeedbackassistantButton = computed(() => AppConfig.urls.assistantModeButtons?.feedbackAssistantButton.enabled === true)
const showCallAssistantButton = computed(() => AppConfig.urls.assistantModeButtons?.callAssistantButton.enabled === true && 
AppConfig.urls.assistantModeButtons?.callAssistantButton?.url !== '')

const router = useRouter();

const publishingDateFormated = computed(() => {
	const publishingDate = props.callout?.mainOutcome?.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});

const showPrequziDialog = ref( false )
const showPostquizDialog = ref( false )
const showKeymessagesDialog = ref( false )
const showGallery = ref( true )

// KeyMessages fetch state
const isLoadingKeyMessages = ref(false)
const fetchedKeyMessages = ref<string | null>(null)

const keyMessagesContent = computed(() => {
  return fetchedKeyMessages.value ?? props.callout.mainOutcome.keyMessages
})

const stopInlineAudio = () => {
	window.dispatchEvent(new CustomEvent('stop-inline-audio'));
};

const openPreQuizDialog = () => {
	stopInlineAudio();
	showPrequziDialog.value = true;
};

const openPostQuizDialog = () => {
	stopInlineAudio();
	showPostquizDialog.value = true;
};

const openKeyMessagesDialog = async () => {
	stopInlineAudio();
	showKeymessagesDialog.value = true;
	
	// Fetch keyMessages with parameters
	if (keyMessagesUrl.value) {
		isLoadingKeyMessages.value = true;
		try {
			console.log('[KeyMessages] Fetching from:', keyMessagesUrl.value);
			const response = await fetch(keyMessagesUrl.value, {
				method: 'GET',
				headers: { 'Content-Type': 'application/json' },
			});
			
			const contentType = response.headers.get('content-type');
			if (!contentType || !contentType.includes('application/json')) {
				console.log('[KeyMessages] Response is not JSON, using existing data');
				return;
			}
			
			if (!response.ok) {
				console.log('[KeyMessages] HTTP error, using existing data:', response.status);
				return;
			}
			
			const data = await response.json();
			console.log('[KeyMessages] Fetched data:', data);
			
			if (data?.mainOutcome?.keyMessages) {
				fetchedKeyMessages.value = data.mainOutcome.keyMessages;
			} else if (data?.keyMessages) {
				fetchedKeyMessages.value = data.keyMessages;
			} else {
				console.log('[KeyMessages] Invalid response structure, using existing data');
			}
		} catch (error) {
			console.log('[KeyMessages] Fetch error, using existing data:', error);
		} finally {
			isLoadingKeyMessages.value = false;
		}
	}
};

const labels = computed( () => messages[props.selectedLanguage] );

// const detailsRoute = computed(() => {
//   return {
//     base:'https://google.com',
// 	name: 'details',
//     params: {
//       ...router.currentRoute.value.params,
//       id: props.callout.identifier
//     },
//     query: {
//       ...router.currentRoute.value.query
//     }
//   }
// })
const goToFeedbackPage = () => {
	router.push({ name: 'feedback', params: { id: props.callout.identifier } });
};


const feedbackUrl = computed(() => {
  const baseUrl = AppConfig.urls.feedback?.url ?? ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const feedbacktype = props.configcollection?.feedbacktype ?? "AJS"
  const separator = baseUrl.includes("?") ? "&" : "?"
  const fullUrl = `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}&feedbacktype=${feedbacktype}`
  //console.log("[Feedback URL]", fullUrl)
  return fullUrl
})

const feedbackListUrl = computed(() => {
  const baseUrl = AppConfig.urls.feedback?.listUrl ?? ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const feedbacktype = props.configcollection?.feedbacktype ?? "AJS"
  const separator = baseUrl.includes("?") ? "&" : "?"
  const fullUrl = `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}&feedbacktype=${feedbacktype}`
  //console.log("[Feedback URL]", fullUrl)
  return fullUrl
})

const preQuizUrl = computed(() => {
  const baseUrl = props.callout._links?.preQuiz?.href ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const postQuizUrl = computed(() => {
  const baseUrl = props.callout._links?.postQuiz?.href ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const keyMessagesUrl = computed(() => {
  const baseUrl = props.callout._links?.mainOutcomeEdit?.href ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const playerFileUrl = computed(() => {
  const baseUrl = props.callout.file_url ?? ""
  if (!baseUrl) return ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const editPackageUrl = computed(() => {
  const baseUrl = AppConfig.urls.editPackage ?? ""
  const id = props.callout.identifier ?? ""
  const packageLng = props.selectedLanguage ?? ""
  const sourcereqid = AppConfig.PAGE_REQ_ID ?? ""
  const separator = baseUrl.includes("?") ? "&" : "?"
  const editAllUrl = `${baseUrl}${separator}id=${id}&full_package=y&lng=${packageLng}&sourcereqid=${sourcereqid}`
  return editAllUrl
})

const getListBaseUrl = () => {
	const raw = String(AppConfig.urls.getList ?? '').trim()
	if (!raw) {
		return ''
	}

	try {
		const url = new URL(raw, window.location.origin)
		url.search = ''
		url.hash = ''
		return url.toString().replace(/\/$/, '')
	} catch {
		return raw.replace(/[?#].*$/, '').replace(/\/$/, '')
	}
}

const detailsItemLng = computed(() => {
	const itemLng = String(props.callout.mainOutcome?.lng ?? '').trim()
	if (itemLng) {
		return itemLng
	}
	return String(props.selectedLanguage ?? currentLng.value ?? '').trim()
})

const applyDetailsContext = (rawUrl: string) => {
	try {
		const url = new URL(rawUrl, window.location.origin)
		url.searchParams.set('json', 'y')
		url.searchParams.set('mode', 'details')
		const selectedLng = detailsItemLng.value
		if (selectedLng) {
			url.searchParams.set('lng', selectedLng)
		}
		if (currentCollectionMode.value) {
			url.searchParams.set('collection-mode', String(currentCollectionMode.value))
		}
		if (currentTestyourself.value) {
			url.searchParams.set('testYourself', String(currentTestyourself.value))
		}
		if (currentPAGE_REQ_ID.value) {
			url.searchParams.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
		}
		return url.toString()
	} catch {
		const params = new URLSearchParams({
			json: 'y',
			mode: 'details',
		})
		const selectedLng = detailsItemLng.value
		if (selectedLng) {
			params.set('lng', selectedLng)
		}
		if (currentCollectionMode.value) {
			params.set('collection-mode', String(currentCollectionMode.value))
		}
		if (currentTestyourself.value) {
			params.set('testYourself', String(currentTestyourself.value))
		}
		if (currentPAGE_REQ_ID.value) {
			params.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
		}
		const separator = rawUrl.includes('?') ? '&' : '?'
		return `${rawUrl}${separator}${params.toString()}`
	}
}

const learnMoreDetailsUrl = computed(() => {
	const baseApi = getListBaseUrl()
	const identifier = props.callout.identifier
	if (baseApi && identifier) {
		return applyDetailsContext(`${baseApi}/${encodeURIComponent(String(identifier))}`)
	}

	const explicitDetailsUrl = String(props.callout._links?.details?.href ?? '').trim()
	if (explicitDetailsUrl) {
		return applyDetailsContext(explicitDetailsUrl)
	}
	return ''
})


onBeforeUnmount(() => {
//   sessionStorage.setItem('listScrollPosition', window.scrollY.toString());
});

onMounted(() => {
//   const savedScroll = sessionStorage.getItem('listScrollPosition');
//   if (savedScroll) {
//     setTimeout(() => {
//       window.scrollTo({
//         top: parseInt(savedScroll),
//         behavior: 'auto'
//       });
//       sessionStorage.removeItem('listScrollPosition');
//     }, 50); // delay i vogël për të pritur DOM-in
//   }
});
</script>

<style>
span.p-image.p-component.p-image-preview-container.rounded{
	width:100%;
}
.p-tooltip {
	font-size: 13px;
}

.p-inplace-display {
	display: flex;
	padding: 0;
	margin: 0;
}

#leadText .p-inplace-display {
	display: flex;
	padding: 0;
	margin: 0;
	align-items: end;
}

.drop-zone {
	border: 2px dashed #ccc;
	padding: 20px;
	margin: 10px 0;
	text-align: center;
	cursor: pointer;
}

.image-zone img {
	max-width: 100%;
	height: auto;
}

.spinnerAssistant {
   width: 24px;
   height: 24px;
   border-radius: 50%;
   border: 3px solid;
   border-color: transparent;
   border-left-color: var(--danger);
   border-right-color: var(--danger);
   animation: spinner-d3wgkg 1s infinite linear;
}

@keyframes spinner-d3wgkg {
   to {
      transform: rotate(1turn);
   }
}
.p-dropdown-panel .p-dropdown-items {
    padding: 0.25rem 0.25rem;
}

#editKeyMessaggesWrapper > ol{
    list-style: decimal-leading-zero !important;
    margin: 0 1em !important;
    padding: 0 20px 0 20px !important;
}
#editKeyMessaggesWrapper > ul, #editKeyMessaggesWrapper > menu {
    list-style: disc !important;
    margin: 0 1em !important;
    padding: 0 20px 0 20px !important;
}
.disabled {
  opacity: 0.5;
background-color:#ddd;	
  pointer-events: none;
  cursor:not-allowed;
}
.p-image-mask.p-component-overlay.p-component-overlay-enter{
    z-index: 8888;
}
</style>
